import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { IconButtonComponent } from './icon-button.component';

@NgModule({
  declarations: [IconButtonComponent],
  imports: [IonicModule],
  exports: [IconButtonComponent],
})
export class IconButtonModule {}
